import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "ui/gluestack/icon";
import { useSectionQuestions } from "../context/SectionQuestionsContext";
import { Text } from "react-native";
import { useAssessmentEditPage } from "../context/AssessmentEditPageContext";

interface Props {
  questionIndex: number;
  sectionIndex: number;
}
export function QuestionOrderAtom({ questionIndex, sectionIndex }: Props) {
  const { questionFields, moveQuestion } = useSectionQuestions();

  const { moveQuestionToSection, sectionsFields } = useAssessmentEditPage();
  const sectionCount = sectionsFields.length;

  return (
    <View className="flex flex-row gap-2">
      {/* Cross-section move controls */}
      <View className="bg-gray-100 rounded p-1">
        <ButtonTextLabel>Section</ButtonTextLabel>
        <View className="flex flex-row gap-2">
          <Button
            size="xs"
            variant="link"
            onPress={() =>
              moveQuestionToSection({
                toSectionIndex: sectionIndex - 1,
                fromSectionIndex: sectionIndex,
                questionIndex,
              })
            }
            isDisabled={sectionIndex === 0}
          >
            <ButtonIcon as={ArrowUpIcon} className="min-w-6" />
          </Button>
          <Button
            size="xs"
            variant="link"
            onPress={() =>
              moveQuestionToSection({
                toSectionIndex: sectionIndex + 1,
                fromSectionIndex: sectionIndex,
                questionIndex,
              })
            }
            isDisabled={sectionIndex >= sectionCount - 1}
          >
            <ButtonIcon as={ArrowDownIcon} className="min-w-6" />
          </Button>
        </View>
      </View>

      {/* Order controls */}
      <View className="bg-gray-100 rounded p-1">
        <ButtonTextLabel>Order</ButtonTextLabel>
        <View className="flex flex-row gap-2">
          <Button
            size="xs"
            variant="link"
            onPress={() =>
              questionIndex > 0 &&
              moveQuestion(questionIndex, questionIndex - 1)
            }
            isDisabled={questionIndex === 0}
          >
            <ButtonIcon as={ChevronUpIcon} className="min-w-6" />
          </Button>
          <Button
            size="xs"
            variant="link"
            onPress={() =>
              questionIndex < questionFields.length - 1 &&
              moveQuestion(questionIndex, questionIndex + 1)
            }
            isDisabled={questionIndex === questionFields.length - 1}
          >
            <ButtonIcon as={ChevronDownIcon} className="min-w-6" />
          </Button>
        </View>
      </View>
    </View>
  );
}

function ButtonTextLabel({ children }: { children: string }) {
  return (
    <View>
      <Text className="text-[0.5rem] uppercase text-center text-black text-semibold">
        {children}
      </Text>
    </View>
  );
}
